<template>
<div class="chapter">
<div class="inner_page">
<p class="h1bb" id="d7e278536"><span>endive</span></p>
<p class="h3" id="d7e279036"><span>(Belgian endive, Witloof chicory)</span></p>
<p class="h4" id="d7e279536"><span>C<span class="small"><span class="small">ICHORIUM INTYBUS</span></span></span></p>
<p class="tx1" id="d7e280036"><span>In this book, I use the name “endive” to mean the delicacy, resembling a pale, miniature head of romaine lettuce, that is served at outrageous prices in French restaurants. This chicon is produced by digging up the roots of the summer-sown plants in the fall, storing them in the dark, and harvesting the doomed, blanched shoots that result. A disciplined gardener can get an impressive supply for the cost of a packet of seed. That may be the only way you are likely to get enough endive to cook for company. Shoppers (unless cost is no object) are better off sticking to salads, where the leaves go further.</span></p>
<p class="tx" id="d7e283636"><span>An endive chicon will keep for several days in the refrigerator. Don’t wash it before storage, and keep it dark. The core is the most bitter. You can remove it with a paring knife if you want a milder flavor. (See also chicory.)</span></p>
<p class="h1b" id="d7e285436"><span>escarole</span></p>
<p class="h4" id="d7e285936"><span>C<span class="small"><span class="small">ICHORIUM ENDIVA</span></span></span></p>
<p class="tx1" id="d7e286436"><span>A broad-leaved variety of chicory, escarole resembles a large, blowsy romaine. The flavor is similar to chicory, but the leaves are fleshier. Full-heart Batavian is the most common variety. The heart referred to is the blanched, delicious center, which is sweet with just enough bitter edge to be interesting. Escarole and chicory can be used interchangeably in most recipes. Like chicory, escarole tastes best after a frost, so Northwest-grown crops have a taste as well as environmental advantage over California and Florida imports. (See also chicory.)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c17_r1.vue?5b927ecf